// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiToolbar-root + div {
  height: calc(100% - 97px);
}
.MuiToolbar-root {
  padding: 0 !important;
}
.MuiToolbar-root p {
  margin: inherit;
}
.MuiTableCell-footer {
  border: none !important;
}
.MuiToolbar-root + div div div {
  overflow-y: initial !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/overrides/material-table.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".MuiToolbar-root + div {\n  height: calc(100% - 97px);\n}\n.MuiToolbar-root {\n  padding: 0 !important;\n}\n.MuiToolbar-root p {\n  margin: inherit;\n}\n.MuiTableCell-footer {\n  border: none !important;\n}\n.MuiToolbar-root + div div div {\n  overflow-y: initial !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
